var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal" }, [
    _c(
      "div",
      {
        staticClass: "close",
        attrs: { slot: "top-right" },
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        },
        slot: "top-right"
      },
      [_c("i", { staticClass: "icon icon--type_close" })]
    ),
    _c(
      "div",
      { staticClass: "modal__content" },
      [
        _c(
          "p",
          {
            staticClass:
              "text text--fs_xl text--lh_xs text--color_black text--fw_bold mb-15"
          },
          [_vm._v(_vm._s(_vm._("Your feedback")))]
        ),
        _c("validation-observer", {
          ref: "observer",
          attrs: { tag: "form" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.validateBeforeSubmit($event)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(props) {
                return [
                  _c(
                    "div",
                    { staticClass: "ug-row ug-row--offset_sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "ug-cell ug-cols" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              tag: "div",
                              name: "author",
                              rules: "required"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("ui-input", {
                                        attrs: {
                                          type: "text",
                                          errors: errors,
                                          label: _vm._("Full Name")
                                        },
                                        model: {
                                          value: _vm.formdata.author,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formdata,
                                              "author",
                                              $$v
                                            )
                                          },
                                          expression: "formdata.author"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "ug-cell ug-cols" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              tag: "div",
                              name: "title",
                              rules: "required"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("ui-input", {
                                        attrs: {
                                          type: "text",
                                          errors: errors,
                                          label: _vm._("Feedback Title")
                                        },
                                        model: {
                                          value: _vm.formdata.title,
                                          callback: function($$v) {
                                            _vm.$set(_vm.formdata, "title", $$v)
                                          },
                                          expression: "formdata.title"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "ug-cell ug-cols" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              tag: "div",
                              name: "review",
                              rules: "required"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("div", { staticClass: "control" }, [
                                        _c(
                                          "div",
                                          { staticClass: "control__elements" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "control-input control-input--textarea"
                                              },
                                              [
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.formdata.review,
                                                      expression:
                                                        "formdata.review"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "control-textarea",
                                                  attrs: { name: "review" },
                                                  domProps: {
                                                    value: _vm.formdata.review
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.formdata,
                                                        "review",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "control__label",
                                                class: {
                                                  "is-active":
                                                    _vm.formdata.review.length >
                                                    0
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._("Your comment")
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        errors[0]
                                          ? _c(
                                              "div",
                                              { staticClass: "control__meta" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "control__help"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "help help--type_error",
                                                        class: {
                                                          "is-error": errors[0]
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "ug-cell ug-cols" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              tag: "div",
                              name: "stars",
                              rules: "required"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("div", { staticClass: "control" }, [
                                        _c(
                                          "div",
                                          { staticClass: "control__elements" },
                                          [
                                            _c("star-rating", {
                                              attrs: {
                                                increment: 1,
                                                "round-start-rating": false,
                                                "star-size": 18,
                                                "active-color": "#fde211",
                                                "fixed-points": 1
                                              },
                                              model: {
                                                value: _vm.formdata.stars,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formdata,
                                                    "stars",
                                                    $$v
                                                  )
                                                },
                                                expression: "formdata.stars"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        errors[0]
                                          ? _c(
                                              "div",
                                              { staticClass: "control__meta" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "control__help"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "help help--type_error",
                                                        class: {
                                                          "is-error": errors[0]
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      ),
                      _c("validation-provider", {
                        attrs: { tag: "div", name: "nonFieldErrors" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "ug-cell ug-cols" },
                                    [
                                      errors[0]
                                        ? _c(
                                            "div",
                                            { staticClass: "control mb-20" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "control__meta"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "help help--type_error",
                                                      class: {
                                                        "is-error": errors[0]
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _c("div", { staticClass: "ug-cell ug-cols" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.validateBeforeSubmit($event)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm._("Send review")))]
                        )
                      ])
                    ],
                    1
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-790b20a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-790b20a5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Modals/Review.vue
// module id = 918
// module chunks = 0